<template>
    <div>
        <p class="text-subtitle1">
          Select users to assign them to the client.
        </p>
        <user-search-input v-model="keyword" filled outlined dense />
        <unassigned-client-users-table
          :client-id="client.id"
          :keyword="keyword"
          v-model:selected="selected"
          class="q-mt-md"
          ref="users"
        />
        <div class="text-center q-mt-md">
          <async-btn
            v-show="selected.length"
            :task="task"
            label="Assign"
            color="primary"
            @click="assign"
          />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { User, Client, List } from '@/type';
import UserSearchInput from '@/client-user/UserSearchInput.vue';
import AsyncBtn from '@/components/AsyncBtn.vue';
import notify from '@/components/notify';
import { assignAll } from '@/client-user/client-user';
import UnassignedClientUsersTable from './UnassignedClientUsersTable.vue';

interface Data {
  keyword: string|null,
  selected: User[],
  task: Promise<any>|null,
}

export default defineComponent({
  components: {
    UserSearchInput,
    UnassignedClientUsersTable,
    AsyncBtn,
  },
  props: {
    client: {
      type: Object as () => Client,
      required: true,
    },
  },
  data(): Data {
    return {
      keyword: null,
      selected: [],
      task: null,
    };
  },
  methods: {
    assign(): void {
      const userIds = this.selected.map(cu => cu.id);
      this.task = assignAll(this.client.id, userIds);
      this.task.then(() => {
        const name = `${this.client.lastName}, ${this.client.lastName}`;
        const total = this.selected.length;
        notify(
          `Assigned ${total} user${(total === 1) ? '' : 's'} to ${name}`,
        );

        this.selected.forEach((c) => {
          (this.$refs.users as List).removeItem(c);
        });
        this.selected = [];
      });
    },
  },
});
</script>
